/* FR Fencing - Limite de quantite dissuasive par article (cote front).
   Plafonne la quantite d'une meme variante et affiche un message rouge vers la demande club.
   Config optionnelle via <script type="application/json" data-fr-qty-config> (max, link, msg, label).
   Ecrit sans accent ni backslash pour un upload theme sur. */
(function () {
  var DEFAULTS = { max: 4, link: "/pages/professionnels", msg: "Maximum 4 par article. Pour une quantite superieure, ", label: "faites une demande club" };

  function readConfig(root) {
    var el = (root && root.querySelector("[data-fr-qty-config]")) || document.querySelector("[data-fr-qty-config]");
    var cfg = {};
    if (el) { try { cfg = JSON.parse(el.textContent) || {}; } catch (e) {} }
    var max = parseInt(cfg.max, 10);
    return {
      max: (max > 0) ? max : DEFAULTS.max,
      link: cfg.link || DEFAULTS.link,
      msg: (typeof cfg.msg === "string") ? cfg.msg : DEFAULTS.msg,
      label: (typeof cfg.label === "string") ? cfg.label : DEFAULTS.label
    };
  }

  function ensureStyle() {
    if (document.getElementById("fr-qty-limit-style")) { return; }
    var s = document.createElement("style");
    s.id = "fr-qty-limit-style";
    s.textContent = ".fr-qty-limit{display:none;margin:10px 0 0;font-family:\"Barlow\",sans-serif;font-size:13.5px;line-height:1.45;color:#E11C24;font-weight:500;}.fr-qty-limit.is-visible{display:block;}.fr-qty-limit a{color:#E11C24;font-weight:700;text-decoration:underline;text-underline-offset:2px;}.fr-qty-limit a:hover{color:#B81820;}";
    document.head.appendChild(s);
  }

  function init(root) {
    if (!root || root.dataset.frQtyLimitBound === "1") { return; }
    var input = root.querySelector(".quantity__input") || root.querySelector("[name=\"quantity\"]");
    if (!input) { return; }
    root.dataset.frQtyLimitBound = "1";
    ensureStyle();
    var cfg = readConfig(root);

    var qtyBlock = root.querySelector(".product-form__quantity") || input.parentElement;
    var msg = document.createElement("div");
    msg.className = "fr-qty-limit";
    msg.setAttribute("role", "status");
    msg.appendChild(document.createTextNode(cfg.msg));
    var a = document.createElement("a");
    a.href = cfg.link;
    a.textContent = cfg.label;
    msg.appendChild(a);
    msg.appendChild(document.createTextNode("."));
    if (qtyBlock && qtyBlock.parentNode) { qtyBlock.parentNode.insertBefore(msg, qtyBlock.nextSibling); }
    else { input.parentNode.appendChild(msg); }

    function apply() {
      var v = parseInt(input.value, 10);
      if (isNaN(v)) { return; }
      if (v > cfg.max) { input.value = cfg.max; v = cfg.max; }
      if (v >= cfg.max) { msg.classList.add("is-visible"); }
      else { msg.classList.remove("is-visible"); }
    }
    function enforceMax() { input.setAttribute("max", cfg.max); }

    enforceMax();
    input.addEventListener("input", apply);
    input.addEventListener("change", apply);
    root.addEventListener("click", function (e) {
      var t = e.target;
      if (t && t.closest && t.closest("[name=\"plus\"]")) { window.setTimeout(apply, 0); }
    });
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      if (PUB_SUB_EVENTS.variantChange) { subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(function () { enforceMax(); apply(); }, 0); }); }
      if (PUB_SUB_EVENTS.quantityUpdate) { subscribe(PUB_SUB_EVENTS.quantityUpdate, function () { window.setTimeout(function () { enforceMax(); apply(); }, 0); }); }
    }
    apply();
  }

  function boot() {
    var roots = document.querySelectorAll("product-info");
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", boot); }
  else { boot(); }
})();
